import { getCardsPool } from "../shared/cards-pool.js";

let cardsPromise = null;
function cards() { return (cardsPromise ||= getCardsPool()); }

export async function renderComposition(target, comp) {
  const pool = await cards();
  target.innerHTML = `
    <header class="cd-head">
      <h2 class="cd-title">${escapeHtml(comp.title)}</h2>
      <p class="cd-desc">${escapeHtml(comp.description || "")}</p>
      <div class="cd-meta">
        <span>${comp.author ? escapeHtml(comp.author) : "anonymous"}</span>
        <span class="cd-dot">·</span>
        <span>${relTime(comp.createdAt)}</span>
      </div>
    </header>
    <div class="cd-canvas" style="width:640px;height:400px;position:relative;margin:16px auto 0;">
      ${comp.cards.map((c) => {
        const card = pool[c.suit][c.index];
        return `<div class="cv-card ${c.suit}" style="left:${c.x}px;top:${c.y}px;">
          <div class="cv-suit-bar"></div>
          <div class="cv-suit-label">${c.suit}</div>
          <div class="cv-name">${escapeHtml(card.n)}</div>
          <div class="cv-desc">${escapeHtml(card.d)}</div>
        </div>`;
      }).join("")}
    </div>
  `;
}

function relTime(ms) {
  const dt = Date.now() - ms;
  const s = Math.floor(dt / 1000);
  if (s < 60) return s + "s ago";
  const m = Math.floor(s / 60); if (m < 60) return m + "m ago";
  const h = Math.floor(m / 60); if (h < 24) return h + "h ago";
  const d = Math.floor(h / 24); if (d < 30) return d + "d ago";
  return new Date(ms).toLocaleDateString();
}
function escapeHtml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
